import styled from 'styled-components';

import { Button } from '@dreryk/react-components';

export const StyledPatientSimpleCreateAction = styled(Button)`
   margin-top: 26px;
   height: 40px;
   flex-shrink: 0;
`;

StyledPatientSimpleCreateAction.displayName = 'StyledPatientSimpleCreateAction';
